import * as React from "react";
import clsx from "clsx";
const Skeleton = (props) => {
  const { label, className, children, theme, ...rest } = props;
  return /* @__PURE__ */ React.createElement("div", { className: clsx("skeleton", className), ...rest, "data-theme": theme }, /* @__PURE__ */ React.createElement("div", { className: "skeleton__content", "aria-hidden": true }, children), /* @__PURE__ */ React.createElement("span", { className: "sr-only" }, label));
};
export {
  Skeleton
};
